import React from 'react';
import PropTypes from 'prop-types';
import { ItemLabelHeader, ItemLabelContent } from '../styled';
import { convertISOToDateFormat } from '../../../../util/timezone';

const VerticalLabelItem = ({ itemLabel, itemValue = '--' }) => {
  if (itemLabel === 'Alert Date') itemValue = convertISOToDateFormat(itemValue);
  return (
    <>
      <ItemLabelHeader>{itemLabel}</ItemLabelHeader>
      <ItemLabelContent>{itemValue}</ItemLabelContent>
    </>
  );
};

VerticalLabelItem.propTypes = {
  itemLabel: PropTypes.string.isRequired,
  itemValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default VerticalLabelItem;
